import React, {useContext, createContext, memo} from 'react'

import useStoredSettingsValueProvider from './StoredSettingsValueContext.hooks'
import type {
  StoredSettingsValueProviderProps,
  StoredSettingsValueContextProps,
} from './StoredSettingsValueContext.types'

const StoredSettingsValueContext = createContext<StoredSettingsValueContextProps>(
  {} as StoredSettingsValueContextProps,
)

function StoredSettingsValueProvider({children}: StoredSettingsValueProviderProps) {
  const store = useStoredSettingsValueProvider()

  return (
    <StoredSettingsValueContext.Provider value={store}>
      {children}
    </StoredSettingsValueContext.Provider>
  )
}

export default memo<StoredSettingsValueProviderProps>(StoredSettingsValueProvider)

export const useStoredSettingsValue = (): StoredSettingsValueContextProps =>
  useContext(StoredSettingsValueContext)
